/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default theme =>({
    contentsort: {
        height: pxToEm(56),
        width: pxToEm(195),
        marginRight: pxToEm(18)
    }
});